import ContactDialog from "@/components/ContactDialog";
import { Megaphone, TrendingUp, ExternalLink } from "lucide-react";

// Two ad units used across the site:
// - "sponsor": shows a real sponsor logo big (square)
// - "advertise": shows an "available space" example to attract new sponsors (rectangular)
export default function AdBanner({ variant = "advertise", sponsor, shape = "leaderboard" }) {
  const tall = shape === "half";

  if (variant === "sponsor" && sponsor) {
    return (
      <a
        href={sponsor.url || "#"}
        target="_blank"
        rel="noreferrer"
        data-testid={`ad-sponsor-${sponsor.name?.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
        className={`relative flex flex-col items-center justify-center rounded-sm border border-slate-200 dark:border-slate-800 bg-white overflow-hidden group ${tall ? "min-h-[260px]" : "min-h-[120px]"} p-6`}
      >
        <div className="absolute top-0 left-0 bg-legend-yellow text-legend-ink text-[9px] font-mono uppercase tracking-widest px-2 py-0.5">Pubblicità</div>
        <img src={sponsor.logo} alt={sponsor.name} className={`object-contain ${tall ? "max-h-40" : "max-h-20"} max-w-[80%] group-hover:scale-105 transition-transform`} />
        <span className="mt-3 inline-flex items-center gap-1 text-[11px] text-slate-500 group-hover:text-legend-red">{sponsor.name} <ExternalLink size={11} /></span>
      </a>
    );
  }

  // advertise / available space
  return (
    <div className={`relative flex ${tall ? "flex-col text-center min-h-[260px]" : "min-h-[120px]"} items-center justify-center gap-4 rounded-sm border-2 border-dashed border-legend-red/50 bg-gradient-to-r from-slate-900 to-legend-ink text-white overflow-hidden p-6`} data-testid="ad-advertise">
      <div className="absolute top-0 left-0 bg-legend-red text-white text-[9px] font-mono uppercase tracking-widest px-2 py-0.5">Spazio pubblicitario</div>
      <div className="checkered absolute right-0 top-0 h-full w-20 opacity-10" />
      <div className={`flex ${tall ? "flex-col items-center" : "items-center"} gap-3 z-10`}>
        <Megaphone size={tall ? 34 : 26} className="text-legend-yellow" />
        <div className={tall ? "text-center" : ""}>
          <p className="font-display font-black uppercase text-xl md:text-2xl leading-none">Il tuo brand qui</p>
          <p className="text-xs text-slate-300 mt-1 max-w-md">Migliaia di appassionati di rally ogni mese. Promuovi la tua azienda con Legend Magazine.</p>
        </div>
      </div>
      <ContactDialog
        kind="sponsor"
        title="Diventa Inserzionista"
        trigger={
          <button data-testid="ad-become-sponsor" className="z-10 inline-flex items-center gap-2 bg-legend-red hover:bg-legend-dark text-white text-sm font-bold uppercase tracking-wide px-4 py-2 rounded-sm transition-colors">
            <TrendingUp size={14} /> Diventa inserzionista
          </button>
        }
      />
    </div>
  );
}
